import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.js'; // Create this file

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const username = e.target.username.value;
    const password = e.target.password.value;

    if (username === 'admin' && password === 'student') {
      setError('');
      onLogin();
      navigate('/dashboard');
    } else {
      setError('❌ Invalid username or password. Please try again.');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <h1 className="login-title">Welcome Back 👋</h1>
        <p className="login-subtitle">Please login to continue</p>
        <form onSubmit={handleSubmit} className="login-form">
          <input
            name="username"
            placeholder="Username"
            className="login-input"
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            className="login-input"
            required
          />
          <button type="submit" className="login-button">Login</button>
        </form>
        {error && <p className="login-error">{error}</p>}
      </div>
    </div>
  );
};

export default Login;
